import type { RouteRecordRaw } from 'vue-router';

export const projectsRoute: RouteRecordRaw = {
  path: '/projects',
  name: 'Projects',
  component: () => import('./pages/ProjectsPage.vue'),
  meta: {
    title: 'Projects',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('tm:core:projects:list'),
  },
};
